import React from 'react';
import { EContext } from '../EContext';

export const text = translations => (placeholder: React.ReactNode, id: string, replacements?: object) => {
    let text = translations[id];

    if (text) {
        return replacements ? translations.replace(id, replacements) : text;
    }

    return placeholder;
};

interface Props {
    children: React.ReactNode;
    id: string;
    replacements?: object;
}

export default function Text({ children, id, replacements }: Props) {
    const { texts } = React.useContext(EContext);
    return text(texts)(children, id, replacements);
}
